export class DsPinHistory {
  /**
   *
   */
  public id: number | null = null;

  /**
   *
   */
  public pinId: number | null = null;

  /**
   *
   */
  public datetime: number | null;

  /**
   *
   */
  public pinState: number | null = null;

  /**
   *
   */
  public accountID: number | null = null;

  /**
   *
   */
  public accountLastname: string | null;

  /**
   *
   */
  public acountSurname: string | null;

  /**
   * Creates an instance of DsPinHistory.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    this.id = jsonData.id || this.id;
    this.pinId = jsonData.pinId || this.pinId;
    this.datetime = jsonData.datetime || this.datetime;
    this.pinState = jsonData.pinSate >= 0 && jsonData.pinSate <= 6 ? jsonData.pinSate : this.pinState;
    this.accountID = jsonData.accountID || this.accountID;
    this.accountLastname =
      jsonData.accountLastname || jsonData.accountLastname === '' ? jsonData.accountLastname : this.accountLastname;
    this.acountSurname =
      jsonData.acountSurname || jsonData.acountSurname === '' ? jsonData.acountSurname : this.acountSurname;
  }
}
